import { WizardStep } from "@mittwald/flow-components/dist/components/Wizard/components/WizardStep";
import React from "react";
import { AdditionalServicesStepContent } from "./AdditionalServicesStepContent";

export const AdditionalServicesStep: React.FC = () => {
  return (
    <WizardStep id="additionalServices" indicatorText="additionalServices">
      <AdditionalServicesStepContent />
    </WizardStep>
  );
};
